"use client";
import{jsx as t}from"react/jsx-runtime";import{forwardRef as r}from"react";const a=r((function(r,a){const{dataCy:o,...e}=r;return t("a",{ref:a,...e,"data-cy":o||"atoms-link"})}));export{a as default};
